module.exports = __webpack_public_path__ + "img/no-profile.320a8ebd.jpg";